import { type FC } from 'react'
import { useTheme } from '@mui/material/styles'

import { type CommonIllustrationType, type Illustrations } from './BaseIllustration.types'
import * as styles from './styles'

export type BaseIllustrationProps = CommonIllustrationType & {
  illustrations: Illustrations
}

const BaseIllustration: FC<BaseIllustrationProps> = ({ mode, size, illustrations, ...rest }) => {
  const theme = useTheme()

  const {
    palette: { mode: themeMode },
  } = theme

  const Illustration = illustrations[mode][themeMode]

  return <Illustration css={styles.illustration(size)} {...rest} aria-hidden />
}

export default BaseIllustration
